import { Button, Code, Collapse, Stack } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconChevronDown, IconChevronRight } from "@tabler/icons-react";
import type { FC } from "react";
import { FormattedMessage } from "react-intl";

export interface CommandPreviewProps {
  /** Ordered list of command blocks to display. Each is a shell-ready string. */
  commands: string[];
}

/**
 * Renders pre-built shell commands as read-only code blocks behind a
 * "Command preview" expand toggle. Used to preview the ogr2ogr /
 * tippecanoe / tile-join invocations that will run server-side.
 */
export const CommandPreview: FC<CommandPreviewProps> = ({ commands }) => {
  const [opened, { toggle }] = useDisclosure(false);

  if (commands.length === 0) return null;

  return (
    <Stack gap="xs">
      <Button
        variant="subtle"
        color="gray"
        onClick={toggle}
        leftSection={opened ? <IconChevronDown size="1rem" /> : <IconChevronRight size="1rem" />}
        justify="flex-start"
        fullWidth
      >
        <FormattedMessage id="button.commandPreview" defaultMessage="Command preview" />
      </Button>

      <Collapse expanded={opened}>
        <Stack gap="xs">
          {commands.map(command => (
            <Code block key={command}>{command}</Code>
          ))}
        </Stack>
      </Collapse>
    </Stack>
  );
};
